import * as React from 'react';
import { useSelector } from 'react-redux';
import { PriceAverage } from '../../components/MarketPrice';
import { selectEstimationPrettyPrices } from '../../selectors/estimation/selectEstimationPrettyPrices';
import { useGetChanges } from '../MarketPriceContainer/utils/useGetChanges';
import { selectDealType, selectIsWebview } from '../../selectors/page';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { EstimationChartContainer } from '../EstimationChartContainer';
import { trackEstimationHistoryOpen, trackEstimationValueInfoOpen } from './tracking';
import { EDealType } from '../../types/dealType';
import { useGetTooltipContent } from './utils';
import { selectEstimationChartState } from '../../selectors/estimationChart';

export const PriceAverageContainer: React.FC = () => {
  const estimationPrices = useSelector(selectEstimationPrettyPrices);
  const dealType = useSelector(selectDealType);

  const isDesktop = useIsDesktop();
  const isWebview = useSelector(selectIsWebview);

  const [isModalOpen, setIsOpen] = React.useState(false);
  const [isChartOpen, setIsChartOpen] = React.useState(false);

  const openChart = React.useCallback(() => {
    setIsChartOpen(true);
    trackEstimationHistoryOpen();
  }, []);

  const onOpenInformer = React.useCallback(() => {
    trackEstimationValueInfoOpen();
  }, []);

  const openModal = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const changes = useGetChanges();

  const priceAverageTooltipContent = useGetTooltipContent();

  const { isError, data: chartData } = useSelector(selectEstimationChartState);
  const isChartAvailable = Boolean(!isError && chartData);

  if (!estimationPrices) {
    return null;
  }

  const priceDescription = dealType === EDealType.Sale ? 'Средняя оценка' : 'Средняя оценка ставки';
  const priceRangeDescription = 'Диапазон оценки';

  const { price, priceFrom, priceTo } = estimationPrices as NonNullable<typeof estimationPrices>;
  const priceChange = `${priceFrom} – ${priceTo}`;

  return (
    <PriceAverage
      price={`Средняя оценка: ${price}`}
      priceRange={priceChange}
      priceDescription={priceDescription}
      priceRangeDescription={priceRangeDescription}
      openModal={openModal}
      closeModal={closeModal}
      changes={changes}
      isWebview={isWebview}
      isModalOpen={isModalOpen}
      isDesktop={isDesktop}
      isChartOpen={isChartOpen}
      setIsChartOpen={openChart}
      chart={<EstimationChartContainer />}
      isChartAvailable={isChartAvailable}
      onOpenInformer={onOpenInformer}
      tooltipContent={priceAverageTooltipContent}
    />
  );
};
